export default __webpack_public_path__ + "static/Category6-a685eb02843582bc059bea9d4565e232.jpg";